import { forwardRef } from 'react';

import clsx from 'clsx';

import { footer } from './Modal.css';
import { ModalFooterProps } from './types';

export const ModalFooter = forwardRef<HTMLDivElement, ModalFooterProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div ref={ref} className={clsx(footer, className)} {...props}>
        {children}
      </div>
    );
  },
);

ModalFooter.displayName = 'ModalFooter';
